import { SalesPartnerModel, SalesPartnerModelObject } from "./SalesPartnerModel";

export interface SalesPartnerBankAccountsRequestModel {
  id: number;
  accountName: string;
  accountNumber: string;
  bankName: string;
  ifscCode: string;
  micrCode: string;
  salesPartnerId: number | string;
  accountTypeId: number;
  isActive: boolean;
}
export interface SalesPartnerBankAccountsModel {
  id: number;
  accountName: string;
  accountNumber: string;
  bankName: string;
  ifscCode: string;
  micrCode: string;
  salesPartner: SalesPartnerModel;
  accountTypeId: number;
  isActive: boolean;
}

export interface SalesPartnerBankAccountTypesModel {
  id: number;
  name: string;
}

export const SalesPartnerBankAccountsModelData: SalesPartnerBankAccountsModel = {
  id: 0,
  accountName: '',
  accountNumber: '',
  bankName: '',
  ifscCode: '',
  micrCode: '',
  salesPartner: SalesPartnerModelObject,
  accountTypeId: 0,
  isActive: true,
};
